module.exports = __webpack_public_path__ + "img/icon_sm_cgdd.3b35bfbe.png";